module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAAAXNSR0IArs4c6QAAAN9JREFUSA3V1DsSwiAQBuBgwQ30EjmFV6H0Ps5QUdB6Bz2Fp7CnoIn5SeIEDWEXyThuwYTH7hcKtml+HVrrkzFmv9V/oDaMqf4OH1jouu7svb9tgaMmasOY8ABLKS9CiHu/0dbGZ2gLAxYuKzAgFg4clVKPYbdsXKv5gmvjayisCK6F59BF+FucgibhUpyKrsJcnINmYSrORUlwDi9ByXAKx/rYkabmQH77H88JxVLxfjucQ7cbOxIZRR4LRsIcDwWGNshCQx4GblhrD865K/L63stGuV50HjhuHy3+w+QJR10vv4mgIIEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-dropdown-plan.png
// module id = Fxsz
// module chunks = 1